
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import axios from 'axios'
import SingleSelectField from '../../commons/fields/SingleSelectField.vue'
import { IMainFocusAreaOption, ITsActivityOption } from '@/types/processingSteps'
import { TGenericObject } from '@/types/base'

@Component({
  components: {
    SingleSelectField
  }
})
export default class ForeignOrgaActivityCode extends Vue {
  @Prop() selectedMainFocusAreaCode!: string
  @Prop() selectedTsActivityCode!: string
  @Prop({ default: true }) isEditable!: boolean
  @Prop() formErrors!: TGenericObject

  activityOptionsData: IMainFocusAreaOption[] = []

  localselectedMainFocusAreaCode = ""
  localSelectedTsActivityCode = ""
  mainActivityOptions = []
  tsActivityOptions = []

  url = "/api/v4/processing-steps/activity-code-options/"

  @Watch('selectedMainFocusAreaCode')
  onSelectedMainFocusAreaCodeChange(newVal: string): void {
    this.localselectedMainFocusAreaCode = newVal
  }

  @Watch('localselectedMainFocusAreaCode')
  onLocalMainFocusAreaCodeChange(newVal: string): void {
    this.$emit('update:selectedMainFocusAreaCode', newVal)
  }

  @Watch('selectedTsActivityCode')
  onSelectedTsActivityCodeChange(newVal: string): void {
    this.localSelectedTsActivityCode = newVal
  }

  @Watch('localSelectedTsActivityCode')
  onLocalTsActivityCodeChange(newVal: string): void {
    this.$emit('update:selectedTsActivityCode', newVal)
  }

  async mounted (): Promise<void> {
    await this.fetchOptions()
    this.setMainActivityOptions()
    this.localSelectedTsActivityCode = this.selectedTsActivityCode
    this.localselectedMainFocusAreaCode = this.selectedMainFocusAreaCode
  }

  async fetchOptions () {
    try {
      const response = await axios.get(this.url)
      this.activityOptionsData = Object.entries(response.data).map(([key, value]) => {
        const typedValue = value as { title: string, activities: Record<string, { title: string }> }
        return {
          code: key,
          title: typedValue.title,
          activities: Object.entries(typedValue.activities).map(([activityKey, activityValue]) => ({
            code: activityKey,
            title: activityValue.title
          }))
        }
      })
    } catch {
      this.$emit('show-error')
    }
  }

  setMainActivityOptions () {
    if (this.activityOptionsData) {
      this.mainActivityOptions = this.activityOptionsData.map((mainFocusArea: IMainFocusAreaOption) => ({
        value: mainFocusArea.code,
        text: mainFocusArea.title,
        activities: mainFocusArea.activities.map((activity: ITsActivityOption) => ({
          value: activity.code,
          text: activity.title
        }))
      }))
    }
  }

  onMainActivitySelected () {
    const selectedMainActivity = this.mainActivityOptions.find(option => option.value === this.localselectedMainFocusAreaCode)
    this.tsActivityOptions = selectedMainActivity ? selectedMainActivity.activities : []
  }
}
